import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000
});

// Inject JWT on every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('speedtest_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401, clear token and redirect to login
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('speedtest_token');
      if (window.location.pathname.startsWith('/admin') &&
          !window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
